const OrderSummaryRow = ({ item }) => (
  <div key={item.ancillaryCd} style={{ display: 'flex', flexWrap: 'wrap' }}>
    <div style={{ width: '3em' }}>{item.quantity}</div>
    <div style={{ marginRight: 'auto' }}>{item.name}</div>
    {item.description && (
      <>
        <div style={{ flexBasis: '100%', height: 0 }}></div>
        <div style={{ paddingLeft: '3em', fontStyle: 'italic' }}>{item.description}</div>
      </>
    )}
  </div>
)

export default OrderSummaryRow
